// Détail d'un retour, déplié sous sa ligne (porté de FeedbackDetail).
import type { JSX } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import type { FeedbackItem } from '@feedbaacks/sdk'
import { useFeedbaacks } from '../context'
import { ArrowRight } from '../icons'
import { Prose } from '../primitives'
import { Comments } from './Comments'
import { MediaViewer } from './media'
import { ContextRead, EditHistory } from './parts'

/** Contexte métier d'un retour (ex. Academy), lisible par tous. « label »
 *  nomme déjà le retour sur sa ligne : il n'est pas répété ici. */
export function BusinessContext({ context }: { context?: Record<string, unknown> }): JSX.Element | null {
  const { t } = useFeedbaacks()
  const entries = Object.entries(context ?? {}).filter(([k, v]) => k !== 'label' && v !== null && v !== undefined && typeof v !== 'object')
  if (!entries.length) return null
  return (
    <dl class="fb-business-context" aria-label={t('business_context')} data-testid="feedbaacks-business-context">
      {entries.map(([k, v]) => (
        <div key={k}>
          <dt>{k}</dt>
          <dd>{String(v)}</dd>
        </div>
      ))}
    </dl>
  )
}

export function Detail({ item, onChange }: { item: FeedbackItem; onChange: (next: FeedbackItem) => void }): JSX.Element {
  const { client, t, options } = useFeedbaacks()
  const [duplicateTitle, setDuplicateTitle] = useState<string | null>(null)
  useEffect(() => {
    if (!item.duplicate_of) return
    client.feedback.get(item.duplicate_of).then((d) => setDuplicateTitle(d.title), () => setDuplicateTitle(null))
  }, [client, item.duplicate_of])

  return (
    <div class="fb-detail" data-testid="feedbaacks-detail">
      {item.body && <Prose text={item.body} class="fb-body" />}
      {item.duplicate_of && (
        <div class="fb-card fb-duplicate">
          <ArrowRight size={14} />
          <span class="fb-muted">{t('duplicate_of')}</span>
          <span class="fb-strong">{duplicateTitle ?? '…'}</span>
        </div>
      )}
      <BusinessContext context={item.context} />
      {options.slots?.detail?.(item)}
      <MediaViewer medias={item.medias} />
      <ContextRead pageUrl={item.page_url} viewport={item.viewport} userAgent={item.user_agent} screenshotUrl={item.screenshot_url} consoleErrors={item.console_errors} />
      <EditHistory history={item.edit_history} />
      <Comments itemId={item.id} count={item.comments_count} onCountChange={(n) => onChange({ ...item, comments_count: n })} />
    </div>
  )
}
